module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "优惠券领取记录",
      "visible": _vm.dialogVisible,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "会员信息",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.subscriberName) + " /\n            " + _vm._s(scope.row.subscriberPhoneNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "couponName",
      "label": "优惠券名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "couponTypeName",
      "label": "优惠券类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useStatusName",
      "label": "使用状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "领取时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useTime",
      "label": "使用时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.toOrderDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.orderNo))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.searchForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.searchForm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.searchForm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-384a6a99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/components/history.vue
// module id = 1643
// module chunks = 0